import httpClient from '../../../shared/services/http/http-client'
import type { IProjectReportWebpageData } from './project-reports.model'

export default class ProjectReportsService {
  http

  constructor() {
    this.http = httpClient
  }

  async getWebpage(projectId: string): Promise<IProjectReportWebpageData> {
    return this.http.get(`project-report/${projectId}/webpage`)
      .then(response => response.data)
      .catch(err => { throw err })
  }

  async getPublicWebpage(projectId: string): Promise<IProjectReportWebpageData> {
    return this.http.get(`public-report/project-report/${projectId}`)
      .then(response => response.data)
      .catch(err => { throw err })
  }
}
